import React, { useEffect, Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { Navigation } from './components/Navigation';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
// Lazy load non-landing pages to reduce initial bundle
const About = lazy(() => import('./pages/About').then(m => ({
  default: m.About
})));
const HowWeFixIt = lazy(() => import('./pages/HowWeFixIt').then(m => ({
  default: m.HowWeFixIt
})));
const WhatsWrong = lazy(() => import('./pages/WhatsWrong').then(m => ({
  default: m.WhatsWrong
})));
const Book = lazy(() => import('./pages/Book').then(m => ({
  default: m.Book
})));
const WhereAIFits = lazy(() => import('./pages/WhereAIFits').then(m => ({
  default: m.WhereAIFits
})));
function ScrollToTop() {
  const {
    pathname,
    hash
  } = useLocation();
  useEffect(() => {
    // If there's a hash, let the browser handle anchor scrolling
    if (hash) {
      setTimeout(() => {
        const element = document.querySelector(hash);
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth'
          });
        }
      }, 0);
    } else {
      // No hash, scroll to top
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);
  return null;
}
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="2zmeoiach9o8k">
      <ScrollToTop data-id="element-1" data-mp="2zmwggus3xgao" />
      <div className="min-h-screen flex flex-col" data-id="element-2" data-mp="2zng1wlgyumtg">
        <Navigation data-id="element-3" data-mp="33nges1of2pye" />
        <Suspense fallback={<div className="min-h-screen bg-[#1D2A3A]" data-id="element-5" data-mp="33oi2p6qj76xj" />} data-id="element-4" data-mp="33myn7icp8zwt">
          <AnimatePresence mode="wait" data-id="element-6" data-mp="38l03xwmnkn54">
            <Routes data-id="element-7" data-mp="38o4gpie6or7e">
              <Route path="/" element={<Home data-id="element-9" data-mp="3dlw6o6v9q38y" />} data-id="element-8" data-mp="3dkl60fx4dbm2" />
              <Route path="/about-john" element={<About data-id="element-11" data-mp="nvj5hlha6osd" />} data-id="element-10" data-mp="3dmfn1j59sjkv" />
              <Route path="/whats-wrong" element={<WhatsWrong data-id="element-13" data-mp="nv0x5qhcgk43" />} data-id="element-12" data-mp="nwc23tmizxws" />
              <Route path="/how-we-fix-it" element={<HowWeFixIt data-id="element-15" data-mp="stub1k0jmd4s" />} data-id="element-14" data-mp="suncc5gqgafj" />
              <Route path="/where-ai-fits" element={<WhereAIFits data-id="element-17" data-mp="36hzjfpzb85g" />} data-id="element-16" data-mp="sssq8ntq6c9v" />
              <Route path="/honest-conversation" element={<Book data-id="element-19" data-mp="38kvshhq5xim" />} data-id="element-18" data-mp="35gld2do25ji" />
              <Route path="/book" element={<Navigate to="/honest-conversation" replace data-id="element-21" data-mp="3ucjdbw1bwfus" />} data-id="element-20" data-mp="3ud1ftael3qb5" />
            </Routes>
          </AnimatePresence>
        </Suspense>
        <Footer data-id="element-22" data-mp="85ul7x54696g" />
      </div>
    </BrowserRouter>;
}